/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Box, Chip, Divider, Grid, } from "@mui/material";
import { lightning, nearProtocal, nft_1, nft_2, nft_3, nft_4 } from "assets/images/image";
import P from "components/Font/P";
import CalendarIcon from "components/Svg/CalendarIcon";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function Home() {
  function createData(id, name, calories, fat, carbs, protein) {
    return { id, name, calories, fat, carbs, protein };
  }

  const rows = [
    createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
    createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
    createData('Eclair', 262, 16.0, 24, 6.0),
    createData('Cupcake', 305, 3.7, 67, 4.3),
    createData('Gingerbread', 356, 16.0, 49, 3.9),
  ];

  return (
    <Box sx={{}}>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img src={lightning} alt="lightning" />
          <P style={{ pl: 2 }} fontWeight={600} fontSize={35} fontFamily="Redressed">Featured</P>
        </Box>
        <Box sx={{}}>
          <Grid container >
            <Grid item xs={12} sm={12} md={6} lg={4} xl={3} px={2} mt={2}>
              <Box sx={{ bgcolor: 'third.secondary' }} className="round-5">
                <img src={nft_1} alt="nft-1" className="w-100 round-5" />
                <Box sx={{ px: 2, py: 1 }}>
                  <P>Antisocial Ape Club</P>
                  <Box sx={{ display: 'flex', alignItems: 'center', color: "third.disabledTextColor" }}>
                    <CalendarIcon />
                    <P color="third.disabledTextColor" fontSize={14} style={{ ml: 1, pt: 0.4 }}>5 Feb - 19:00</P>
                  </Box>
                </Box>
                <Divider />
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1 }}>
                  <P uppercase fontSize={12}>Floor price:</P>
                  <Box display={'flex'} alignItems="center">
                    <img src={nearProtocal} style={{ height: 20, }} />
                    <P style={{ ml: 1 }} fontWeight={600}>4.2</P>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={3} px={2} mt={2}>
              <Box sx={{ bgcolor: 'third.secondary' }} className="round-5">
                <img src={nft_2} alt="nft-1" className="w-100 round-5" />
                <Box sx={{ px: 2, py: 1 }}>
                  <P>NearNaut</P>
                  <Box sx={{ display: 'flex', alignItems: 'center', color: "third.disabledTextColor" }}>
                    <CalendarIcon />
                    <P color="third.disabledTextColor" fontSize={14} style={{ ml: 1, pt: 0.4 }}>--</P>
                  </Box>
                </Box>
                <Divider />
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1 }}>
                  <P uppercase fontSize={12}>Mint price:</P>
                  <Box display={'flex'} alignItems="center">
                    <img src={nearProtocal} style={{ height: 20, }} />
                    <P style={{ ml: 1 }} fontWeight={600}>0.77</P>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={3} px={2} mt={2}>
              <Box sx={{ bgcolor: 'third.secondary' }} className="round-5">
                <img src={nft_3} alt="nft-1" className="w-100 round-5" />
                <Box sx={{ px: 2, py: 1 }}>
                  <P>Solpacas</P>
                  <Box sx={{ display: 'flex', alignItems: 'center', color: "third.disabledTextColor" }}>
                    <CalendarIcon />
                    <P color="third.disabledTextColor" fontSize={14} style={{ ml: 1, pt: 0.4 }}>17 Feb - 08:00</P>
                  </Box>
                </Box>
                <Divider />
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1 }}>
                  <P uppercase fontSize={12}>Mint price:</P>
                  <Box display={'flex'} alignItems="center">
                    <img src={nearProtocal} style={{ height: 20, }} />
                    <P style={{ ml: 1 }} fontWeight={600}>0.15</P>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={3} px={2} mt={2}>
              <Box sx={{ bgcolor: 'third.secondary' }} className="round-5">
                <img src={nft_4} alt="nft-1" className="w-100 round-5" />
                <Box sx={{ px: 2, py: 1 }}>
                  <P>Broyuko Dragoz</P>
                  <Box sx={{ display: 'flex', alignItems: 'center', color: "third.disabledTextColor" }}>
                    <CalendarIcon />
                    <P color="third.disabledTextColor" fontSize={14} style={{ ml: 1, pt: 0.4 }}>19 Feb - 21:00</P>
                  </Box>
                </Box>
                <Divider />
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1 }}>
                  <P uppercase fontSize={12}>Mint price:</P>
                  <Box display={'flex'} alignItems="center">
                    <img src={nearProtocal} style={{ height: 20, }} />
                    <P style={{ ml: 1 }} fontWeight={600}>343</P>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box mt={10}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <P style={{ pl: 2 }} fontWeight={600} fontSize={35} fontFamily="Redressed">All Collections</P>
        </Box>
        <Box px={2}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell><P fontSize={12}>#</P></TableCell>
                  <TableCell><P uppercase fontSize={12}>Collection</P></TableCell>
                  <TableCell align="right"><P uppercase fontSize={12}>Floor price</P></TableCell>
                  <TableCell align="right"><P uppercase fontSize={12}>Owners</P></TableCell>
                  <TableCell align="right"><P uppercase fontSize={12}>Sales <span className="th-chip-span">24h</span> </P> </TableCell>
                  <TableCell align="right"><P uppercase fontSize={12}>Volume <span className="th-chip-span">24h</span></P></TableCell>
                  <TableCell align="right"><P uppercase fontSize={12}>Market Cap</P></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell>1</TableCell>
                  <TableCell component="th" scope="row">
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <img src={nft_1} alt="nft-1" style={{ width: 56, height: 56, borderRadius: 5 }} />
                      <Box sx={{ pl: 2 }}>
                        <P>Antisocial Ape Club</P>
                        <P uppercase fontSize={15} color="third.disabledTextColor">Supply: <span className="td-first-col-span">3333</span> </P>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell align="right">
                    <Box display={'flex'} alignItems="center" justifyContent="right">
                      <img src={nearProtocal} style={{ height: 20, }} />
                      <P style={{ ml: 1 }} fontWeight={600}>343</P>
                    </Box>
                  </TableCell>
                  <TableCell align="right"><P>122 <span className="down-rate-span">(-13)</span> </P></TableCell>
                  <TableCell align="right"><P>55 <span className="up-rate-span">(+35%)</span> </P></TableCell>
                  <TableCell align="right"><P>$12,321</P></TableCell>
                  <TableCell align="right"><P>$2,865,464</P></TableCell>
                </TableRow>
                <TableRow
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell>2</TableCell>
                  <TableCell component="th" scope="row">
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <img src={nft_2} alt="nft-1" style={{ width: 56, height: 56, borderRadius: 5 }} />
                      <Box sx={{ pl: 2 }}>
                        <P>NearNaut</P>
                        <P uppercase fontSize={15} color="third.disabledTextColor">Supply: <span className="td-first-col-span">7745</span> </P>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell align="right">
                    <Box display={'flex'} alignItems="center" justifyContent="right">
                      <img src={nearProtocal} style={{ height: 20, }} />
                      <P style={{ ml: 1 }} fontWeight={600}>342</P>
                    </Box>
                  </TableCell>
                  <TableCell align="right"><P>63 <span className="up-rate-span">(+22)</span> </P></TableCell>
                  <TableCell align="right"><P>863 <span className="down-rate-span">(-7%)</span> </P></TableCell>
                  <TableCell align="right"><P>$77,575</P></TableCell>
                  <TableCell align="right"><P>$343,885</P></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </Box >
  );
}

export default Home;
